import React from 'react';
import { BrowserRouter as Router, Route, Link, Switch,useHistory ,useLocation    } from "react-router-dom";

import {  MDBContainer, MDBMask, MDBView, MDBFooter } from 'mdbreact';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme, alpha  } from '@material-ui/core/styles';
import purple from '@material-ui/core/colors/purple';
import orange from '@material-ui/core/colors/orange';
import Home from '../Home';
import Studentreport from './Studentreport';
import Studentschoolreport from './Studentschoolreport';
import Studentschoolreportconfirm from './Studentschoolreportconfirm';
import Studentkpru from './Studentkpru';
import StudentDropout from './StudentDropout';
import StudentGraduate from './StudentGraduate';
import Studentcurr from './Studentcurr';
import Studentfinish from './Studentfinish';
import Studentschoolmis from './Studentschoolmis';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import Button from '@material-ui/core/Button';
import PeopleIcon from '@material-ui/icons/People';

import logo2 from '../img/mmu.png'

import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import "@fontsource/kanit";
import Login from './../Student/Login';
import Swal from 'sweetalert2/dist/sweetalert2.js'

import Doctoraldegree from '../degree/Doctoraldegree';
import Bachelordegree from '../degree/Bachelordegree';
import Masterdegree from '../degree/Masterdegree';
import Certificatecourse from '../degree/Certificatecourse';
import teacherbachelordegree from '../degreelevel/teacherbachelordegree';
import teachermasterdegree from '../degreelevel/teachermasterdegree';
import teacherdoctoraldegree from '../degreelevel/teacherdoctoraldegree';
import teeteacherbachelordegree from '../degreelevel/teeteacherbachelordegree';
import toteacherbachelordegree from '../degreelevel/toteacherbachelordegree';
import aekteacherbachelordegree from '../degreelevel/aekteacherbachelordegree';
import apteeteacher from '../degreelevel/apteeteacher';
import apaekteacher from '../degreelevel/apaekteacher';
import aptoteacher from '../degreelevel/aptoteacher';
import Asspteeteacher from '../degreelevel/Asspteeteacher';
import Asspaekteacher from '../degreelevel/Asspaekteacher';
import Assptoteacher from '../degreelevel/Assptoteacher';
import Proaekteacher from '../degreelevel/Proaekteacher';
import Prototeacher from '../degreelevel/Prototeacher';
import Proteeteacher from '../degreelevel/Proteeteacher';
import teacherculiculumtee from '../teacherculiculum/teacherculiculumtee';
import teacherculiculumto from '../teacherculiculum/teacherculiculumto';
import teacherculiculumaek from '../teacherculiculum/teacherculiculumaek';
import teacherculiculumno from '../teacherculiculum/teacherculiculumno';
import teacherculiculumap from '../teacherculiculum/teacherculiculumap';
import teacherculiculumassp from '../teacherculiculum/teacherculiculumassp';
import teacherculiculumpro from '../teacherculiculum/teacherculiculumpro';
import welcome from './welcome';
import Studentworkall from '../studentwork/Studentworkall';
import Studentsentworkafteryear from '../studentwork/Studentsentworkafteryear';
import Studentworkforfinsh from '../studentwork/Studentworkforfinsh';
import Studentworkfreelance from '../studentwork/Studentworkfreelance';
import Studentgetworkbeforlearn from '../studentwork/Studentgetworkbeforlearn';
import Studentworksalary from '../studentwork/Studentworksalary';
import Studentcontinuing from '../studentwork/Studentcontinuing';
import Studenttqf from '../studentwork/Studenttqf';
import Studentregularincome from '../studentwork/Studentregularincome';
import Studentordination from '../studentwork/Studentordination';
import Studentsoldier from '../studentwork/Studentsoldier';
import Sitemap from '../Sitemap';
import Masterreport from '../superadmin/Masterreport';
import Academicto01 from '../academicstudent/Academicto01';
import Academicto02 from '../academicstudent/Academicto02';
import Academicto03 from '../academicstudent/Academicto03';
import Academicto04 from '../academicstudent/Academicto04';
import Academicto05 from '../academicstudent/Academicto05';
import Academicto06 from '../academicstudent/Academicto06';
import Academicto07 from '../academicstudent/Academicto07';
import Academicto08 from '../academicstudent/Academicto08';
import Academicto09 from '../academicstudent/Academicto09';
import Academicto10 from '../academicstudent/Academicto10';
import Academicto11 from '../academicstudent/Academicto11';
import Academicto12 from '../academicstudent/Academicto12';
import Academicto13 from '../academicstudent/Academicto13';
import Academicto14 from '../academicstudent/Academicto14';
import Academicaek01 from '../academicstudent/Academicaek01';
import Academicaek02 from '../academicstudent/Academicaek02';
import Academicaek03 from '../academicstudent/Academicaek03';
import Academicaek04 from '../academicstudent/Academicaek04';
import Academicaek05 from '../academicstudent/Academicaek05';
import Academicaek06 from '../academicstudent/Academicaek06';
import Academicaek07 from '../academicstudent/Academicaek07';
import Academicaek08 from '../academicstudent/Academicaek08';
import Academicaek09 from '../academicstudent/Academicaek09';
import Academicaek10 from '../academicstudent/Academicaek10';
import Academicaek11 from '../academicstudent/Academicaek11';
import Academicaek12 from '../academicstudent/Academicaek12';
import Academicaek13 from '../academicstudent/Academicaek13';
import Academicaek14 from '../academicstudent/Academicaek14';
import Publicreport from '../superadmin/Publicreport';
import Academicth01 from '../academicteacher/Academicth01';
import Academicth02 from '../academicteacher/Academicth02';
import Academicth03 from '../academicteacher/Academicth03';
import Academicth04 from '../academicteacher/Academicth04';
import Academicth05 from '../academicteacher/Academicth05';
import Academicth06 from '../academicteacher/Academicth06';
import Academicth07 from '../academicteacher/Academicth07';
import Academicth08 from '../academicteacher/Academicth08';
import Academicth09 from '../academicteacher/Academicth09';
import Academicth10 from '../academicteacher/Academicth10';
import Academicth11 from '../academicteacher/Academicth11';
import Academicth12 from '../academicteacher/Academicth12';
import Academicth13 from '../academicteacher/Academicth13';
import Academicth14 from '../academicteacher/Academicth14';
import Academicth15 from '../academicteacher/Academicth15';
import Academicth16 from '../academicteacher/Academicth16';
import Academicth17 from '../academicteacher/Academicth17';
import Academicth18 from '../academicteacher/Academicth18';
import Academicth19 from '../academicteacher/Academicth19';
import Studentschoolservicearea from './Studentschoolservicearea';
import Publicresearch from '../superadmin/Publicresearch';
import Publicall from '../researchandpublic/Publicall';
import Researchall from '../researchandpublic/Researchall';
import Studentprofession from './Studentprofession';
import Studentmasterdegree from './Studentmasterdegree';
import Footter from '../../Component/Footter';
import Foottermobil from '../../Component/Foottermobil';
import Bachelordegreeopen from '../degree/Bachelordegreeopen';
import teacherall from '../degreelevel/teacherall';
import Studentworkall2 from '../studentwork/Studentworkall2';
import Studentconfirmservicearea from './Studentconfirmservicearea';
import Certificatecourseopen from '../degree/Certificatecourseopen';
import Doctoraldegreeopen from '../degree/Doctoraldegreeopen';
import teacherculiculumall from '../degreelevel/teacherculiculumall';
import Studentmov from './Studentmov';
import Nursepersonnel from '../nurse/Nursepersonnel';
import Academicth011 from '../academicteacher/Academicth011';
import Empnum from '../emp/Empnum';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Nurseproject from '../nurse/Nurseproject';
import Nursebudget from '../nurse/Nursebudget';
import Nursetotalbudget from '../nurse/Nursetotalbudget';
import Studentreportstatus from './Studentreportstatus';
import Studentkpruonschool from './Studentkpruonschool';
import Nurseteacher from '../nurse/Nurseteacher';
import Nurseresearch from '../nurse/Nurseresearch';
import Nursepublic from '../nurse/Nursepublic';
import Nursedurablearticles from '../nurse/Nursedurablearticles';
import Nursenumstd from '../nurse/Nursenumstd';
import Nursecurriculum from '../nurse/Nursecurriculum';
import Studentkprutoregister from './Studentkprutoregister';
import Studentreportyear from './Studentreportyear';
import Nursemko from '../nurse/Nursemko';
import Editpasswordmember from '../superadmin/Editpasswordmember';
import Nursebook from '../nurse/Nursebook';
import Nurseestimate from '../nurse/Nurseestimate';
import Nursenumgraduate from '../nurse/Nursenumgraduate';
import NurseAcademicservices from '../nurse/NurseAcademicservices';
import Nurseartsandculture from '../nurse/Nurseartsandculture';
import Nursedevelopstudents from '../nurse/Nursedevelopstudents';
import NurseActivitytype from '../nurse/NurseActivitytype';

import Loginforapp from './../Student/Loginforapp';
import Numfinshstudent from '../superadmin/Numfinshstudent';
import Updatedataall from '../superadmin/Updatedataall';
import StudentNotpaid from './StudentNotpaid';
import Masterreportssy from '../superadmin/Masterreportssy';
import Masterreportpay from '../superadmin/Masterreportpay';
import Masterreportpositionnumber from '../superadmin/Masterreportpositionnumber';
import Retire from '../emp/Retire';
import Nurseteachertostudent from '../nurse/Nurseteachertostudent';
import Culiculumcreditbank from '../degreelevel/Culiculumcreditbank';
import Schoolcreditbank from '../degreelevel/Schoolcreditbank';



































const pddp = window.location.pathname;
console.log(pddp);

const pp = 1;
const drawerWidth = 275;
const drawerWidth2 = 300;
const accent = purple['A200'];
const accent2 = orange['A100'];
const ddd = 'IconButton'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    backgroundColor:alpha(theme.palette.grey[400], 2.55),
 
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    
    },
  },
  //เต็มจอ
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      backgroundColor:alpha(theme.palette.grey[300], 2.55),
      // backgroundImage: `url(${top2})`,
      //  backgroundImage: `url(${"https://img.freepik.com/premium-vector/fashion-stylish-pastel-color-design-with-abstract-curves-lines-stoke-pastel-colorful_293525-390.jpg?w=1060"})`,
      // bgcolor: '#FF6600',
    },
//จอเล็ก mobil
    backgroundColor: alpha(theme.palette.grey[300], 2.55),
    // backgroundColor: theme.palette.background.paper,
  },
  menuButton: {
    marginRight: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
    
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
   // backgroundColor: theme.palette.warning.light,
      backgroundImage: `url(${"https://w0.peakpx.com/wallpaper/159/225/HD-wallpaper-material-design-orange-and-black-geometric-shapes-black-backgrounds-geometric-art-creative-background-with-lines.jpg"})`,
  
   fontFamily:"Kanit",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(0),
   // marginLeft:0,
    //paddingLeft:1,
   // paddingRight:1,
  

  },
  nested2: {
    paddingLeft: theme.spacing(3),
   // paddingLeft:1,
    background: "#898A8A",
    '&:hover': {
       background: "#ffbb33",
       color: 'black',
    },
  },

  nested2at: {
    paddingLeft: theme.spacing(4),
   // paddingLeft:1,
    background: "#c2c5aa",
    '&:hover': {
       background: "#ffbb33",
       color: 'black',
    },
  },

  nested3: {
    paddingLeft: theme.spacing(2),
   // paddingLeft:1,
    background: "#fffcf2",
    '&:hover': {
       background: "#eb5e28",
       color: 'black',
    },
  },

  nested2sub: {
    paddingLeft: theme.spacing(3),
    background: "#bdbdbd",
    '&:hover': {
       background: "#ffe57f",
       color: 'black',
    },
  },


  lists: {
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(1),
  },
  paperContainer: {
   // backgroundImage: `url(${"https://img.freepik.com/free-vector/hand-painted-watercolor-pastel-sky-background_23-2148902771.jpg?w=2000"})`
  },

  fontFamily: [
    'Kanit',
    'kanit',
  ].join(','),

}));


function Main(props) {
  const { window2 } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);







  const [open, setOpen] = React.useState(false);
  const [open01, setOpen01] = React.useState(false);
  const [open02, setOpen02] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);
  const [open41, setOpen41] = React.useState(false);
  const [open42, setOpen42] = React.useState(false);
  const [open43, setOpen43] = React.useState(false);
  const [open44, setOpen44] = React.useState(false);
  const [open45, setOpen45] = React.useState(false);
  const [open5, setOpen5] = React.useState(false);
  const [open51, setOpen51] = React.useState(false);
  const [open52, setOpen52] = React.useState(false);
  const [open6, setOpen6] = React.useState(false);
  const [open61, setOpen61] = React.useState(false);
  const [open7, setOpen7] = React.useState(false);
  const [open80, setOpen80] = React.useState(false);
  const [open8, setOpen8] = React.useState(false);
  const [open9, setOpen9] = React.useState(false);
  const [open10, setOpen10] = React.useState(false);
  const [open11, setOpen11] = React.useState(false);
  const [open12, setOpen12] = React.useState(false);
  const [open13, setOpen13] = React.useState(false);
  const [open14, setOpen14] = React.useState(false);
  const [open15, setOpen15] = React.useState(false);
  const [open16, setOpen16] = React.useState(false);
  const [open17, setOpen17] = React.useState(false);
  const [open18, setOpen18] = React.useState(false);
  const [open19, setOpen19] = React.useState(false);

  const [open49, setOpen49] = React.useState(false);
  const [open50, setOpen50] = React.useState(false);
  const [openadmin, setopenadmin] = React.useState(false);

  const handleClick = () => {setOpen((prevOpen) => !prevOpen);};
  const handleClick01 = () => {setOpen01((prevOpen) => !prevOpen);};
  const handleClick02 = () => {setOpen02((prevOpen) => !prevOpen);};
  const handleClick2 = () => {setOpen2((prevOpen) => !prevOpen); };
  const handleClick3 = () => {setOpen3((prevOpen) => !prevOpen); };
  const handleClick4 = () => {setOpen4((prevOpen) => !prevOpen); };
  const handleClick41 = () => {setOpen41((prevOpen) => !prevOpen); };
  const handleClick42 = () => {setOpen42((prevOpen) => !prevOpen); };
  const handleClick43 = () => {setOpen43((prevOpen) => !prevOpen); };
  const handleClick44 = () => {setOpen44((prevOpen) => !prevOpen); };
  const handleClick45 = () => {setOpen45((prevOpen) => !prevOpen); };
  const handleClick5 = () => {setOpen5((prevOpen) => !prevOpen); };
  const handleClick51 = () => {setOpen51((prevOpen) => !prevOpen); };
  const handleClick52 = () => {setOpen52((prevOpen) => !prevOpen); };
  const handleClick6 = () => {setOpen6((prevOpen) => !prevOpen); };
  const handleClick61 = () => {setOpen61((prevOpen) => !prevOpen); };
  const handleClick7 = () => {setOpen7((prevOpen) => !prevOpen); };
  const handleClick80 = () => {setOpen80((prevOpen) => !prevOpen); };
  const handleClick8 = () => {setOpen8((prevOpen) => !prevOpen); };
  const handleClick9 = () => {setOpen9((prevOpen) => !prevOpen); };
  const handleClick10 = () => {setOpen10((prevOpen) => !prevOpen); };
  const handleClick11 = () => {setOpen11((prevOpen) => !prevOpen); };
  const handleClick12 = () => {setOpen12((prevOpen) => !prevOpen); };
  const handleClick13 = () => {setOpen13((prevOpen) => !prevOpen); };
  const handleClick14 = () => {setOpen14((prevOpen) => !prevOpen); };
  const handleClick15 = () => {setOpen15((prevOpen) => !prevOpen); };
  const handleClick16 = () => {setOpen16((prevOpen) => !prevOpen); };
  const handleClick17 = () => {setOpen17((prevOpen) => !prevOpen); };
  const handleClick18 = () => {setOpen18((prevOpen) => !prevOpen); };
  const handleClick19 = () => {setOpen19((prevOpen) => !prevOpen); };

  const handleClick49 = () => {setOpen49((prevOpen) => !prevOpen); };
  const handleClick50 = () => {setOpen50((prevOpen) => !prevOpen); };
  const handleClickadmin = () => {setopenadmin((prevOpen) => !prevOpen); };

const history = useHistory();

  const logout = () => {
    localStorage.clear();
    window.location.href = '/login'

    // Swal.fire({
    //   title: 'ยืนยันการออกจากระบบ',
    // //  imageUrl: 'http://localhost:3000/kprudashboard/static/media/mmu.c8e448e4.png',
    //   icon: 'question',
    // // showCancelButton: true,
    //   confirmButtonText: 'ตกลง',
    // // cancelButtonText: 'No, keep it'
    // }).then((result) => {
    //       window.location.href = '/kprudashboard/login'
    // })

  // window.location="http://www.ireallyhost.com"
 //  window().location.href = 'https://e-student.kpru.ac.th/info'
   // window.location.reload(false);
  //  window.location.reload()
   // history.push('/login')
   // window.location.reload()
  
   // window.location.href ('/');
    // setTimeout(() => {
    
    // }, 1000);
  };

  

  const useStyles2 = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: 360,
     // background: "#E9EDF1",
    },
    lists: {
      backgroundColor: theme.palette.background.paper,
      marginTop: theme.spacing(1),
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
  }));
  


  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div  >
      {/* <div className={classes.toolbar} /> */}
      <div className="text-center " >
          <br/>
            <img src={logo2}  width="100"  />
            <p className='text-white'>มหาวิทยาลัยราชภัฏกำแพงเพชร</p>
            <p className='orange-text'>{localStorage.getItem('name')}<br/>{localStorage.getItem('type2') == '9'?<> <Button size="small" className='text-white'   component={Link} to="/Editpasswordmember" >แก้ไขรหัสผ่าน</Button></>:<></>}</p>
      </div>
    
       {/* <p>fgfg</p>  */}

      <Divider />
      {/* <List>
        {['ด้านนักศึกษา', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
          <ListItem button key={text} component={Link} to="/Studentfinish">
            
            <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
            <ListItemText primary={text}  />
          </ListItem>
        ))}
      </List> */}
          {/* selected={"/Bachelordegree" === this.props.location.pathname } */}
  <div className='gradientgroup'>
       <br/>
       <div className='bgc'>
         <p className='text-center mb-1 '>ด้านจัดการเรียนการสอน</p> 
       </div>
   
      <ListItem button onClick={handleClick} >
          <ListItemIcon  className='text-white'>
            <InboxIcon />
          </ListItemIcon>
         <ListItemText primary="หลักสูตร" className='text-white'  /> 
          {open ? <ExpandLess className='text-white'/> : <ExpandMore className='text-white'/>}
      </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>

          <List component="div" disablePadding>


                       <ListItem button  key="หลักสูตรที่พัฒนา/ปรับปรุง" onClick={handleClick01} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="หลักสูตรที่พัฒนา/ปรับปรุง"  />
                           {open01 ? <ExpandLess  /> : <ExpandMore  />}
                        </ListItem>
                        <Collapse in={open01} timeout="auto" unmountOnExit>

                        <ListItem button key="ระดับปริญญาตรี" className={classes.nested2sub}   component={Link} to="/Bachelordegree" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ระดับปริญญาตรี" />
                          </ListItem>

                          <ListItem button key="ระดับ ป.บัณฑิต" className={classes.nested2sub}   component={Link} to="/Certificatecourse" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ระดับ ป.บัณฑิต" />
                          </ListItem>

                          <ListItem button key="ระดับปริญญาโท" className={classes.nested2sub}  component={Link} to="/Masterdegree" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ระดับปริญญาโท" />
                          </ListItem>
                      

                          <ListItem button key="ระดับปริญญาเอก" className={classes.nested2sub}  component={Link} to="/Doctoraldegree" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ระดับปริญญาเอก" />
                          </ListItem>
                          
                          </Collapse>

                       <ListItem button  key="หลักสูตรที่เปิดสอน" onClick={handleClick02} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="จำนวนหลักสูตรที่เปิดสอน"  />
                           {open02 ? <ExpandLess  /> : <ExpandMore  />}
                        </ListItem>
                        <Collapse in={open02} timeout="auto" unmountOnExit>

                        <ListItem button key="ระดับปริญญาตรี" className={classes.nested2sub}   component={Link} to="/Bachelordegreeopen" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ระดับปริญญาตรี" />
                          </ListItem>

                          <ListItem button key="ระดับ ป.บัณฑิต" className={classes.nested2sub}   component={Link} to="/Certificatecourseopen" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ระดับ ป.บัณฑิต" />
                          </ListItem>

                          <ListItem button key="ระดับปริญญาโท เอก" className={classes.nested2sub}  component={Link} to="/Doctoraldegreeopen" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ระดับปริญญาโท เอก" />
                          </ListItem>
                      

                          {/* <ListItem button key="ระดับปริญญาเอก" className={classes.nested2sub}  component={Link} to="/Bachelordegreeopen" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ระดับปริญญาเอก" />
                          </ListItem> */}
                          </Collapse>


          </List>
        </Collapse>

        

        {/* <ListItem button onClick={handleClick2}>
          <ListItemIcon className='text-white'>
            <InboxIcon />
          </ListItemIcon>
          <ListItemText primary="จำนวนหลักสูตรนอกที่ตั้ง" className='text-white kanits'/>
          {open2 ? <ExpandLess className='text-white' /> : <ExpandMore className='text-white' />}
        </ListItem>
        <Collapse in={open2} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
          <ListItem button key="ระดับปริญญาตรี" className={classes.nested2}   component={Link} to="" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ระดับปริญญาตรี" />
            </ListItem>

            <ListItem button key="ระดับ ป.บัณฑิต" className={classes.nested2}   component={Link} to="" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ระดับ ป.บัณฑิต" />
            </ListItem>

            <ListItem button key="ระดับปริญญาโท" className={classes.nested2}  component={Link} to="" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ระดับปริญญาโท" />
            </ListItem>

            <ListItem button key="ระดับ ป.บัณฑิต ขั้นสูง" className={classes.nested2}  component={Link} to="" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ระดับ ป.บัณฑิต ขั้นสูง" />
            </ListItem>

            <ListItem button key="ระดับปริญญาเอก" className={classes.nested2}  component={Link} to="" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ระดับปริญญาเอก" />
            </ListItem>
          </List>
        </Collapse> */}
     
  
     
{/*      
      <ListItem button key="รายงานตัว" component={Link} to="/Studentschoolreportconfirm">
            <ListItemIcon>{1 % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
            <ListItemText primary="รายงานตัว"  />
      </ListItem>
  */}
      {/* จำนวนผู้สมัครเรียน*/}
      <ListItem button onClick={handleClick10} >
          <ListItemIcon  className='text-white'>
            <InboxIcon />
          </ListItemIcon>
         <ListItemText primary="ข้อมูลผู้สมัครเรียน" className='text-white'  /> 
          {open10 ? <ExpandLess className='text-white'/> : <ExpandMore className='text-white'/>}
      </ListItem>
        <Collapse in={open10} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

           <ListItem button key="จำนวนผู้สมัครเรียน" className={classes.nested2}   component={Link} to="/Studentreport" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนผู้สมัครเรียน" />
            </ListItem>

            {/* <ListItem button key="จำนวนผู้สมัครเรียนแยกสถานะ" className={classes.nested2}   component={Link} to="/Studentreportstatus" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนผู้สมัครเรียนแยกสถานะ" />
            </ListItem> */}

                 <ListItem button key="จำนวนผู้สมัครเรียนแยกปี" className={classes.nested2}   component={Link} to="/Studentreportyear" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนผู้สมัครเรียนแยกปี" />
            </ListItem>

            <ListItem button key="จำนวนผู้รายงานตัว" className={classes.nested2}   component={Link} to="/Studentschoolreportconfirm" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนผู้รายงานตัว" />
            </ListItem>
            <ListItem button key="ผู้สมัครในพื้นที่ให้บริการและนอกพื้นที่ให้บริการ" className={classes.nested2}   component={Link} to="/Studentschoolservicearea" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ผู้สมัครในพื้นที่ให้บริการและนอกพื้นที่ให้บริการ" />
            </ListItem>
            <ListItem button key="ผู้รายงานตัวในพื้นที่ให้บริการและนอกพื้นที่ให้บริการ" className={classes.nested2}   component={Link} to="/Studentconfirmservicearea" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ผู้รายงานตัวในพื้นที่ให้บริการและนอกพื้นที่ให้บริการ" />
            </ListItem>

          
          </List>
        </Collapse>



      <ListItem button onClick={handleClick3}>
          <ListItemIcon className='text-white fontFamily'>
            <InboxIcon />
          </ListItemIcon>
          <ListItemText primary="นักศึกษา" className='text-white ' />
          {open3 ? <ExpandLess className='text-white' /> : <ExpandMore  className='text-white'/>}
        </ListItem>
        <Collapse in={open3} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>


            <ListItem button key="นักศึกษาเปรียบเทียบผู้สมัคร" className={classes.nested2}  component={Link} to="/Studentkprutoregister" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="นักศึกษาเปรียบเทียบผู้สมัคร" />
            </ListItem>

            <ListItem button key="ระดับปริญญาตรี" className={classes.nested2}  component={Link} to="/Studentkpru" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ระดับปริญญาตรี" />
            </ListItem>

            <ListItem button key="ระดับปริญญาตรีแยกโรงเรียนเดิม" className={classes.nested2}  component={Link} to="/Studentkpruonschool" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ระดับปริญญาตรีแยกโรงเรียนเดิม" />
            </ListItem>

            <ListItem button key="ระดับ ป.บัณฑิต" className={classes.nested2}  component={Link} to="/Studentprofession" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ระดับ ป.บัณฑิต" />
            </ListItem>

            <ListItem button key="ระดับปริญญาโท ปริญญาเอก" className={classes.nested2}  component={Link} to="/Studentmasterdegree" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ระดับปริญญาโท ปริญญาเอก" />
            </ListItem>

            <ListItem button key="จำนวนผู้สำเร็จ" className={classes.nested2}  component={Link} to="/Studentfinish" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนผู้สำเร็จ" />
            </ListItem>

            <ListItem button key="จำนวนผู้ออกกลางคัน" className={classes.nested2}  component={Link} to="/StudentDropout" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนผู้ออกกลางคัน" />
            </ListItem>

            <ListItem button key="นักศึกษาต่างชาติ ปริญญาตรี" className={classes.nested2}  component={Link} to="/Studentmov" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="นักศึกษาต่างชาติ ปริญญาตรี" />
            </ListItem>

                 <ListItem button key="นักศึกษายังไม่ชำระเงินลงทะเบียน" className={classes.nested2}  component={Link} to="/StudentNotpaid" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="นักศึกษายังไม่ชำระเงินลงทะเบียน" />
            </ListItem>
           
          </List>
        </Collapse>


{/* จำนวนการมีงานทำของบัณฑิต */}
<ListItem button onClick={handleClick7}>
          <ListItemIcon className='text-white'>
            <InboxIcon />
          </ListItemIcon>
          <ListItemText primary="บัณฑิต" className='text-white kanits'/>
          {open7 ? <ExpandLess className='text-white' /> : <ExpandMore className='text-white' />}
        </ListItem>
        <Collapse in={open7} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button key="จำนวนบัณฑิตระดับปริญญาตรีทั้งหมด" className={classes.nested2}   component={Link} to="/Studentworkall2" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนบัณฑิตระดับปริญญาตรีทั้งหมด" />
            </ListItem>

            {/* <ListItem button key="จำนวนบัณฑิตระดับปริญญาตรีที่ตอบแบบสำรวจเรื่องการงานทำภายใน 1 ปี หลังสำเร็จการศึกษา" className={classes.nested2}   component={Link} to="/Studentsentworkafteryear" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนบัณฑิตระดับปริญญาตรีที่ตอบแบบสำรวจเรื่องการงานทำภายใน 1 ปี หลังสำเร็จการศึกษา" />
            </ListItem> */}

            <ListItem button key="การมีงานทำของบัณฑิตระดับปริญญาตรี" className={classes.nested2}  component={Link} to="/Studentworkforfinsh" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="การมีงานทำของบัณฑิตระดับปริญญาตรี" />
            </ListItem>

            {/* <ListItem button key="จำนวนบัณฑิตระดับปริญญาตรีที่ประกอบอาชีพอิสระ" className={classes.nested2}  component={Link} to="/Studentworkfreelance" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนบัณฑิตระดับปริญญาตรีที่ประกอบอาชีพอิสระ" />
            </ListItem>

            <ListItem button key="จำนวนผู้สำเร็จการศึกษาระดับปริญญาตรีที่มีงานทำก่อนเข้าศึกษา" className={classes.nested2}  component={Link} to="/Studentgetworkbeforlearn" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนผู้สำเร็จการศึกษาระดับปริญญาตรีที่มีงานทำก่อนเข้าศึกษา" />
            </ListItem>

            <ListItem button key="จำนวนบัณฑิตระดับปริญญาตรีที่ศึกษาต่อระดับบัณฑิตศึกษา" className={classes.nested2}  component={Link} to="/Studentcontinuing" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนบัณฑิตระดับปริญญาตรีที่ศึกษาต่อระดับบัณฑิตศึกษา" />
            </ListItem>

            <ListItem button key="เงินเดือนหรือรายได้ต่อเดือนของผู้สำเร็จการศึกษาระดับปริญญาตรีที่ได้งานทำหรือประกอบอาชีพอิสระ" className={classes.nested2}  component={Link} to="/Studentworksalary" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="เงินเดือนหรีอรายได้ต่อเดือนของผู้สำเร็จการศึกษาระดับปริญญาตรีที่ได้งานทำหรือประกอบอาชีพอิสระ" />
            </ListItem>

            <ListItem button key="ผลการประเมินจากความพึงพอใจของนายจ้างที่มีต่อผู้สำเร็จการศึกษาระดับปริญญาตรีตามกรอบ TQF" className={classes.nested2}  component={Link} to="/Studenttqf" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ผลการประเมินจากความพึงพอใจของนายจ้างที่มีต่อผู้สำเร็จการศึกษาระดับปริญญาตรีตามกรอบ TQF" />
            </ListItem>

            <ListItem button key="จำนวนบัณฑิตระดับปริญญาตรีที่มีกิจกรรมของตนเองที่มีรายได้ประจำอยู่แล้ว" className={classes.nested2}  component={Link} to="/Studentregularincome" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนบัณฑิตระดับปริญญาตรีที่มีกิจกรรมของตนเองที่มีรายได้ประจำอยู่แล้ว" />
            </ListItem>

            <ListItem button key="จำนวนบัณฑิตระดับปริญญาตรีที่อุปสมบท" className={classes.nested2}  component={Link} to="/Studentordination" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนบัณฑิตระดับปริญญาตรีที่อุปสมบท" />
            </ListItem>

            <ListItem button key="จำนวนบัณฑิตระดับปริญญาตรีที่เกณฑ์ทหาร" className={classes.nested2}  component={Link} to="/Studentsoldier" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนบัณฑิตระดับปริญญาตรีที่เกณฑ์ทหาร" />
            </ListItem> */}

          </List>
        </Collapse>





        {/* <ListItem button onClick={handleClick80} >
          <ListItemIcon  className='text-white'>
            <InboxIcon />
          </ListItemIcon>
         <ListItemText primary="ผลงานทางวิชาการของผู้สำเร็จการศึกษาระดับปริญญาโท เอก" className='text-white'  /> 
          {open80 ? <ExpandLess className='text-white'/> : <ExpandMore className='text-white'/>}
      </ListItem>
        <Collapse in={open80} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

                          <ListItem button onClick={handleClick8} className={classes.nested2} >
                                <ListItemIcon  >
                                  <PeopleIcon />
                                </ListItemIcon>
                              <ListItemText primary="ผลงานทางวิชาการของผู้สำเร็จการศึกษาระดับปริญญาโท"   /> 
                                {open8 ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                              <Collapse in={open8} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                  <ListItem button key="จำนวนบทความฉบับสมบูรณ์ที่มีการตีพิมพ์ในลักษณะใดลักษณะหนึ่ง" className={classes.nested2sub}   component={Link} to="/Academicto01" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนบทความฉบับสมบูรณ์ที่มีการตีพิมพ์ในลักษณะใดลักษณะหนึ่ง" />
                                  </ListItem>

                                  <ListItem button key="จำนวนบทความฉบับสมบูรณ์ที่มีการตีพิมพ์ในรายงานสืบเนื่องจากการประชุมวิชาการระดับชาติ" className={classes.nested2sub}   component={Link} to="/Academicto02" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนบทความฉบับสมบูรณ์ที่มีการตีพิมพ์ในรายงานสืบเนื่องจากการประชุมวิชาการระดับชาติ" />
                                  </ListItem>

                                  <ListItem button key="จำนวนบทความฉบับสมบูรณ์ที่มีการตีพิมพ์ในรายงานสืบเนื่องจากการประชุมวิชาการระดับนานาชาติ" className={classes.nested2sub}  component={Link} to="/Academicto03" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนบทความฉบับสมบูรณ์ที่มีการตีพิมพ์ในรายงานสืบเนื่องจากการประชุมวิชาการระดับนานาชาติ" />
                                  </ListItem>

                                  <ListItem button key="ผลงานที่ได้รับการจดอนุสิทธิบัตร" className={classes.nested2sub}  component={Link} to="/Academicto04" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="ผลงานที่ได้รับการจดอนุสิทธิบัตร" />
                                  </ListItem>

                                  <ListItem button key="จำนวนบทความที่ตีพิมพ์ในวารสารวิชาการที่ปรากฏในฐานข้อมูล tci กลุ่มที่2" className={classes.nested2sub}  component={Link} to="/Academicto05" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนบทความที่ตีพิมพ์ในวารสารวิชาการที่ปรากฏในฐานข้อมูล tci กลุ่มที่2" />
                                  </ListItem>

                                  <ListItem button key="จำนวนบทความที่ตีพิมพ์ในวารสารวิชาการระดับนานาชาติ ที่ไม่อยู่ในฐานข้อมูลตามประกาศ ก.พ.อ." className={classes.nested2sub}  component={Link} to="/Academicto06" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนบทความที่ตีพิมพ์ในวารสารวิชาการระดับนานาชาติ ที่ไม่อยู่ในฐานข้อมูลตามประกาศ ก.พ.อ." />
                                  </ListItem>

                                  <ListItem button key="จำนวนบทความที่ตีพิมพ์ในวารสารวิชาการระดับนานาชาติ ที่ปรากฏอยู่ในฐานข้อมูลระดับนานาชาติตามประกาศ ก.พ.อ." className={classes.nested2sub}  component={Link} to="/Academicto07" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนบทความที่ตีพิมพ์ในวารสารวิชาการระดับนานาชาติ ที่ปรากฏอยู่ในฐานข้อมูลระดับนานาชาติตามประกาศ ก.พ.อ." />
                                  </ListItem>

                                  <ListItem button key="ผลงานที่ได้รับการจดสิทธิบัตร" className={classes.nested2sub}  component={Link} to="/Academicto08" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="ผลงานที่ได้รับการจดสิทธิบัตร" />
                                  </ListItem>

                                  <ListItem button key="จำนวนผลงานสร้างสรรค์ที่มีการเผยแพร่สู่สาธารณะในลักษณะใดลักษณะหนึ่ง หรือผ่านสื่ออิเล็กทรอนิกส์ online" className={classes.nested2sub}  component={Link} to="/Academicto09" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนผลงานสร้างสรรค์ที่มีการเผยแพร่สู่สาธารณะในลักษณะใดลักษณะหนึ่ง หรือผ่านสื่ออิเล็กทรอนิกส์ online" />
                                  </ListItem>

                                  <ListItem button key="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับสถาบัน" className={classes.nested2sub}  component={Link} to="/Academicto10" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับสถาบัน" />
                                  </ListItem>

                                  <ListItem button key="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับชาติ" className={classes.nested2sub}  component={Link} to="/Academicto11" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับชาติ" />
                                  </ListItem>

                                  <ListItem button key="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับความร่วมมือระหว่างประเทศ" className={classes.nested2sub}  component={Link} to="/Academicto12" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับความร่วมมือระหว่างประเทศ" />
                                  </ListItem>

                                  <ListItem button key="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับภูมิภาคอาเซียน" className={classes.nested2sub}  component={Link} to="/Academicto13" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับภูมิภาคอาเซียน" />
                                  </ListItem>

                                  <ListItem button key="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับนานาชาติ" className={classes.nested2sub}  component={Link} to="/Academicto14" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับนานาชาติ" />
                                  </ListItem>

                                </List>
                              </Collapse>

                              <ListItem button onClick={handleClick9} className={classes.nested2}>
                                <ListItemIcon  >
                                  <PeopleIcon />
                                </ListItemIcon>
                              <ListItemText primary="ผลงานทางวิชาการของผู้สำเร็จการศึกษาระดับปริญญาเอก"   /> 
                                {open9 ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                              <Collapse in={open9} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                  <ListItem button key="จำนวนบทความฉบับสมบูรณ์ที่มีการตีพิมพ์ในลักษณะใดลักษณะหนึ่ง" className={classes.nested2sub}   component={Link} to="/Academicaek01" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนบทความฉบับสมบูรณ์ที่มีการตีพิมพ์ในลักษณะใดลักษณะหนึ่ง" />
                                  </ListItem>

                                  <ListItem button key="จำนวนบทความฉบับสมบูรณ์ที่มีการตีพิมพ์ในรายงานสืบเนื่องจากการประชุมวิชาการระดับชาติ" className={classes.nested2sub}   component={Link} to="/Academicaek02" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนบทความฉบับสมบูรณ์ที่มีการตีพิมพ์ในรายงานสืบเนื่องจากการประชุมวิชาการระดับชาติ" />
                                  </ListItem>

                                  <ListItem button key="จำนวนบทความฉบับสมบูรณ์ที่มีการตีพิมพ์ในรายงานสืบเนื่องจากการประชุมวิชาการระดับนานาชาติ" className={classes.nested2sub}  component={Link} to="/Academicaek03" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนบทความฉบับสมบูรณ์ที่มีการตีพิมพ์ในรายงานสืบเนื่องจากการประชุมวิชาการระดับนานาชาติ" />
                                  </ListItem>

                                  <ListItem button key="ผลงานที่ได้รับการจดอนุสิทธิบัตร" className={classes.nested2sub}  component={Link} to="/Academicaek04" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="ผลงานที่ได้รับการจดอนุสิทธิบัตร" />
                                  </ListItem>

                                  <ListItem button key="จำนวนบทความที่ตีพิมพ์ในวารสารวิชาการที่ปรากฏในฐานข้อมูล tci กลุ่มที่2" className={classes.nested2sub}  component={Link} to="/Academicaek05" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนบทความที่ตีพิมพ์ในวารสารวิชาการที่ปรากฏในฐานข้อมูล tci กลุ่มที่2" />
                                  </ListItem>

                                  <ListItem button key="จำนวนบทความที่ตีพิมพ์ในวารสารวิชาการระดับนานาชาติ ที่ไม่อยู่ในฐานข้อมูลตามประกาศ ก.พ.อ." className={classes.nested2sub}  component={Link} to="/Academicaek06" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนบทความที่ตีพิมพ์ในวารสารวิชาการระดับนานาชาติ ที่ไม่อยู่ในฐานข้อมูลตามประกาศ ก.พ.อ." />
                                  </ListItem>

                                  <ListItem button key="จำนวนบทความที่ตีพิมพ์ในวารสารวิชาการระดับนานาชาติ ที่ปรากฏอยู่ในฐานข้อมูลระดับนานาชาติตามประกาศ ก.พ.อ." className={classes.nested2sub}  component={Link} to="/Academicaek07" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนบทความที่ตีพิมพ์ในวารสารวิชาการระดับนานาชาติ ที่ปรากฏอยู่ในฐานข้อมูลระดับนานาชาติตามประกาศ ก.พ.อ." />
                                  </ListItem>

                                  <ListItem button key="ผลงานที่ได้รับการจดสิทธิบัตร" className={classes.nested2sub}  component={Link} to="/Academicaek08" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="ผลงานที่ได้รับการจดสิทธิบัตร" />
                                  </ListItem>

                                  <ListItem button key="จำนวนผลงานสร้างสรรค์ที่มีการเผยแพร่สู่สาธารณะในลักษณะใดลักษณะหนึ่ง หรือผ่านสื่ออิเล็กทรอนิกส์ online" className={classes.nested2sub}  component={Link} to="/Academicaek09" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนผลงานสร้างสรรค์ที่มีการเผยแพร่สู่สาธารณะในลักษณะใดลักษณะหนึ่ง หรือผ่านสื่ออิเล็กทรอนิกส์ online" />
                                  </ListItem>

                                  <ListItem button key="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับสถาบัน" className={classes.nested2sub}  component={Link} to="/Academicaek10" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับสถาบัน" />
                                  </ListItem>

                                  <ListItem button key="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับชาติ" className={classes.nested2sub}  component={Link} to="/Academicaek11" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับชาติ" />
                                  </ListItem>

                                  <ListItem button key="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับความร่วมมือระหว่างประเทศ" className={classes.nested2sub}  component={Link} to="/Academicaek12" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับความร่วมมือระหว่างประเทศ" />
                                  </ListItem>

                                  <ListItem button key="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับภูมิภาคอาเซียน" className={classes.nested2sub}  component={Link} to="/Academicaek13" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับภูมิภาคอาเซียน" />
                                  </ListItem>

                                  <ListItem button key="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับนานาชาติ" className={classes.nested2sub}  component={Link} to="/Academicaek14" >
                                    <ListItemIcon>
                                      <StarBorder />
                                    </ListItemIcon>
                                    <ListItemText primary="จำนวนผลงานสร้างสรรค์ที่ได้รับการเผยแพร่ในระดับนานาชาติ" />
                                  </ListItem>

                                </List>
                              </Collapse>


          </List>
        </Collapse> */}


   


  
       {/* จำนวนอาจารย์ */}
        <ListItem button onClick={handleClick4}>
          <ListItemIcon className='text-white'>
            <InboxIcon  />
          </ListItemIcon>
          <ListItemText primary="อาจารย์" className='text-white' />
          {open4 ? <ExpandLess className='text-white' /> : <ExpandMore  className='text-white'/>}
        </ListItem>
        <Collapse in={open4} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

                     <ListItem button key="จำนวนอาจารย์ทั้งหมด" className={classes.nested2}  component={Link} to="/teacherall" >
                        <ListItemIcon>
                          <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary="จำนวนอาจารย์ทั้งหมด" />
                      </ListItem>

                      {/* <ListItem button  key="จำนวนอาจารย์ทั้งหมดปฏิบัติงานและลาศึกษา" onClick={handleClick41} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="จำนวนอาจารย์ทั้งหมดปฏิบัติงานและลาศึกษา"  />
                           {open41 ? <ExpandLess  /> : <ExpandMore  />}
                        </ListItem>
                      <Collapse in={open41} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                          <ListItem button key="วุฒิปริญญาตรีหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/teacherbachelordegree" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาตรีหรือเทียบเท่า" />
                          </ListItem>

                          <ListItem button key="วุฒิปริญญาโทหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/teachermasterdegree" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาโทหรือเทียบเท่า" />
                          </ListItem>

                          <ListItem button key="วุฒิปริญญาเอกหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/teacherdoctoraldegree" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาเอกหรือเทียบเท่า" />
                          </ListItem>

                        </List>
                     </Collapse> */}

                     {/* <ListItem button  key="จำนวนอาจารย์ที่ดำรงตำแหน่งอาจารย์" onClick={handleClick42} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="จำนวนอาจารย์ที่ดำรงตำแหน่งอาจารย์"  />
                           {open42 ? <ExpandLess  /> : <ExpandMore  />}
                        </ListItem>
                      <Collapse in={open42} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                          <ListItem button key="วุฒิปริญญาตรีหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/teeteacherbachelordegree" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาตรีหรือเทียบเท่า" />
                          </ListItem>

                          <ListItem button key="วุฒิปริญญาโทหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/toteacherbachelordegree" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาโทหรือเทียบเท่า" />
                          </ListItem>

                          <ListItem button key="วุฒิปริญญาเอกหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/aekteacherbachelordegree" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาเอกหรือเทียบเท่า" />
                          </ListItem>


                        </List>
                     </Collapse> */}

                     {/* <ListItem button  key="จำนวนอาจารย์ที่ดำรงตำแหน่งผู้ช่วยศาสตราจารย์" onClick={handleClick43} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="จำนวนอาจารย์ที่ดำรงตำแหน่งผู้ช่วยศาสตราจารย์"  />
                           {open43 ? <ExpandLess  /> : <ExpandMore  />}
                        </ListItem>
                      <Collapse in={open43} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                          <ListItem button key="วุฒิปริญญาตรีหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/apteeteacher" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาตรีหรือเทียบเท่า" />
                          </ListItem>

                          <ListItem button key="วุฒิปริญญาโทหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/aptoteacher" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาโทหรือเทียบเท่า" />
                          </ListItem>

                          <ListItem button key="วุฒิปริญญาเอกหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/apaekteacher" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาเอกหรือเทียบเท่า" />
                          </ListItem>

                        </List>
                     </Collapse> */}

                     {/* <ListItem button  key="จำนวนอาจารย์ที่ดำรงตำแหน่งรองศาสตราจารย์" onClick={handleClick44} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="จำนวนอาจารย์ที่ดำรงตำแหน่งรองศาสตราจารย์"  />
                           {open44 ? <ExpandLess  /> : <ExpandMore  />}
                        </ListItem>
                      <Collapse in={open44} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                          <ListItem button key="วุฒิปริญญาตรีหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/Asspteeteacher" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาตรีหรือเทียบเท่า" />
                          </ListItem>

                          <ListItem button key="วุฒิปริญญาโทหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/Assptoteacher" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาโทหรือเทียบเท่า" />
                          </ListItem>

                          <ListItem button key="วุฒิปริญญาเอกหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/Asspaekteacher" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาเอกหรือเทียบเท่า" />
                          </ListItem>

                        </List>
                     </Collapse> */}

                     {/* <ListItem button  key="จำนวนอาจารย์ที่ดำรงตำแหน่งศาสตราจารย์" onClick={handleClick45} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="จำนวนอาจารย์ที่ดำรงตำแหน่งศาสตราจารย์"  />
                           {open45 ? <ExpandLess  /> : <ExpandMore  />}
                        </ListItem>
                      <Collapse in={open45} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                          <ListItem button key="วุฒิปริญญาตรีหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/Proteeteacher" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาตรีหรือเทียบเท่า" />
                          </ListItem>

                          <ListItem button key="วุฒิปริญญาโทหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/Prototeacher" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาโทหรือเทียบเท่า" />
                          </ListItem>

                          <ListItem button key="วุฒิปริญญาเอกหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/Proaekteacher" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาเอกหรือเทียบเท่า" />
                          </ListItem>

                        </List>
                     </Collapse> */}



                     {/* <ListItem button key="จำนวนอาจารย์ประจำหลักสูตรทั้งหมด" className={classes.nested2}  component={Link} to="/teacherculiculumall" >
                        <ListItemIcon>
                          <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary="จำนวนอาจารย์ประจำหลักสูตรทั้งหมด" />
                      </ListItem>


                      <ListItem button  key="จำนวนอาจารย์ประจำหลักสูตรแยกตามวุฒิการศึกษา" onClick={handleClick51} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="จำนวนอาจารย์ประจำหลักสูตรแยกตามวุฒิการศึกษา"  />
                           {open51 ? <ExpandLess  /> : <ExpandMore  />}
                        </ListItem>
                      <Collapse in={open51} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                          <ListItem button key="วุฒิปริญญาตรีหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/teacherculiculumtee" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาตรีหรือเทียบเท่า" />
                          </ListItem>

                          <ListItem button key="วุฒิปริญญาโทหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/teacherculiculumto" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาโทหรือเทียบเท่า" />
                          </ListItem>

                          <ListItem button key="วุฒิปริญญาเอกหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/teacherculiculumaek" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาเอกหรือเทียบเท่า" />
                          </ListItem>

                        </List>
                     </Collapse> */}

                     {/* <ListItem button  key="จำนวนอาจารย์ประจำหลักสูตรที่มีดำรงตำแหน่งทางวิชาการ" onClick={handleClick52} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="จำนวนอาจารย์ประจำหลักสูตรที่มีดำรงตำแหน่งทางวิชาการ"  />
                           {open52 ? <ExpandLess  /> : <ExpandMore  />}
                      </ListItem>
                      <Collapse in={open52} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                          <ListItem button key="ไม่มีตำแหน่งทางวิชาการ" className={classes.nested2sub}  component={Link} to="/teacherculiculumno" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ไม่มีตำแหน่งทางวิชาการ" />
                          </ListItem>

                          <ListItem button key="ตำแหน่งผู้ช่วยศาสตราจารย์" className={classes.nested2sub}  component={Link} to="/teacherculiculumap" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ตำแหน่งผู้ช่วยศาสตราจารย์" />
                          </ListItem>

                          <ListItem button key="ตำแหน่งรองศาสตราจารย์" className={classes.nested2sub}  component={Link} to="/teacherculiculumassp" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ตำแหน่งรองศาสตราจารย์" />
                          </ListItem>

                          <ListItem button key="ตำแหน่งศาสตราจารย์" className={classes.nested2sub}  component={Link} to="/teacherculiculumpro" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ตำแหน่งศาสตราจารย์" />
                          </ListItem>

                        </List>
                     </Collapse> */}
          </List>
        </Collapse>




         {/* จำนวนอาจารย์ */}
        <ListItem button onClick={handleClick6}>
          <ListItemIcon className='text-white'>
            <InboxIcon  />
          </ListItemIcon>
          <ListItemText primary="คลังหน่วยกิต" className='text-white' />
          {open6 ? <ExpandLess className='text-white' /> : <ExpandMore  className='text-white'/>}
        </ListItem>
        <Collapse in={open6} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

                     <ListItem button key="หลักสูตรเชื่อมโยงคลังหน่วยกิต" className={classes.nested2}  component={Link} to="/Culiculumcreditbank" >
                        <ListItemIcon>
                          <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary="หลักสูตรเชื่อมโยงคลังหน่วยกิต" />
                      </ListItem>

                       <ListItem button key="จำนวนโรงเรียนที่ร่วมดำเนินงานคลังหน่วยกิต" className={classes.nested2}  component={Link} to="/Schoolcreditbank" >
                        <ListItemIcon>
                          <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary="จำนวนโรงเรียนที่ร่วมดำเนินงานคลังหน่วยกิต" />
                      </ListItem>

          
          </List>
        </Collapse>


 

        {/* <div className='bgc'>
        <p className='text-center mb-1'>คุณวุฒิ/ผลงานทางวิชาการ</p> 
        </div> */}

         {/* จำนวนอาจารย์ */}
         {/* <ListItem button onClick={handleClick5}>
          <ListItemIcon className='text-white'>
            <InboxIcon  />
          </ListItemIcon>
          <ListItemText primary="คุณวุฒิอาจารย์ประจำหลักสูตร" className='text-white' />
          {open5 ? <ExpandLess className='text-white' /> : <ExpandMore  className='text-white'/>}
        </ListItem>
        <Collapse in={open5} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

                     <ListItem button key="จำนวนอาจารย์ประจำหลักสูตรทั้งหมด" className={classes.nested2}  component={Link} to="/teacherculiculumall" >
                        <ListItemIcon>
                          <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary="จำนวนอาจารย์ประจำหลักสูตรทั้งหมด" />
                      </ListItem>


                      <ListItem button  key="จำนวนอาจารย์ประจำหลักสูตรแยกตามวุฒิการศึกษา" onClick={handleClick51} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="จำนวนอาจารย์ประจำหลักสูตรแยกตามวุฒิการศึกษา"  />
                           {open51 ? <ExpandLess  /> : <ExpandMore  />}
                        </ListItem>
                      <Collapse in={open51} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                          <ListItem button key="วุฒิปริญญาตรีหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/teacherculiculumtee" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาตรีหรือเทียบเท่า" />
                          </ListItem>

                          <ListItem button key="วุฒิปริญญาโทหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/teacherculiculumto" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาโทหรือเทียบเท่า" />
                          </ListItem>

                          <ListItem button key="วุฒิปริญญาเอกหรือเทียบเท่า" className={classes.nested2sub}  component={Link} to="/teacherculiculumaek" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="วุฒิปริญญาเอกหรือเทียบเท่า" />
                          </ListItem>

                        </List>
                     </Collapse>

                     <ListItem button  key="จำนวนอาจารย์ประจำหลักสูตรที่มีดำรงตำแหน่งทางวิชาการ" onClick={handleClick52} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="จำนวนอาจารย์ประจำหลักสูตรที่มีดำรงตำแหน่งทางวิชาการ"  />
                           {open52 ? <ExpandLess  /> : <ExpandMore  />}
                      </ListItem>
                      <Collapse in={open52} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                          <ListItem button key="ไม่มีตำแหน่งทางวิชาการ" className={classes.nested2sub}  component={Link} to="/teacherculiculumno" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ไม่มีตำแหน่งทางวิชาการ" />
                          </ListItem>

                          <ListItem button key="ตำแหน่งผู้ช่วยศาสตราจารย์" className={classes.nested2sub}  component={Link} to="/teacherculiculumap" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ตำแหน่งผู้ช่วยศาสตราจารย์" />
                          </ListItem>

                          <ListItem button key="ตำแหน่งรองศาสตราจารย์" className={classes.nested2sub}  component={Link} to="/teacherculiculumassp" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ตำแหน่งรองศาสตราจารย์" />
                          </ListItem>

                          <ListItem button key="ตำแหน่งศาสตราจารย์" className={classes.nested2sub}  component={Link} to="/teacherculiculumpro" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ตำแหน่งศาสตราจารย์" />
                          </ListItem>

                        </List>
                     </Collapse>

          </List>
        </Collapse> */}


          {/* ผลงานทางวิชาการของอาจารย์ประจำหลักสูตร */}
          {/* <ListItem button onClick={handleClick6}>
          <ListItemIcon className='text-white'>
            <InboxIcon  />
          </ListItemIcon>
          <ListItemText primary="ผลงานทางวิชาการของอาจารย์" className='text-white' />
          {open6 ? <ExpandLess className='text-white' /> : <ExpandMore  className='text-white'/>}
        </ListItem>
        <Collapse in={open6} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

                      <ListItem button  key="จำนวนผลงานทางวิชาการของอาจารย์ประจำหลักสูตร" onClick={handleClick61} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="จำนวนผลงานทางวิชาการของอาจารย์ประจำหลักสูตร"  />
                           {open61 ? <ExpandLess  /> : <ExpandMore  />}
                        </ListItem>
                      <Collapse in={open61} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                        <ListItem button key="จำนวนบทความฉบับสมบูรณ์อาจารย์ประจำหลักสูตรที่มีการตีพิมพ์ในลักษณะใดลักษณะหนึ่ง" className={classes.nested2sub}  component={Link} to="/Academicth011" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="จำนวนบทความฉบับสมบูรณ์อาจารย์ประจำหลักสูตรที่มีการตีพิมพ์ในลักษณะใดลักษณะหนึ่ง" />
                          </ListItem>

                          <ListItem button key="บทความวิจัยหรือบทความวิชาการที่ตีพิมพ์ในรายงานสืบเนื่องจากการประชุมวิชาการ" className={classes.nested2sub}  component={Link} to="/Academicth01" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="บทความวิจัยหรือบทความวิชาการที่ตีพิมพ์ในรายงานสืบเนื่องจากการประชุมวิชาการ" />
                          </ListItem>

                          <ListItem button key="บทความสมบูรณ์ที่ตีพิมพ์ในรายงานสืบเนื่องจากการประชุมวิชาการระดับชาติ หรือวารสารทางวิชาการระดับชาติที่ไม่อยู่ในฐานข้อมูล" className={classes.nested2sub}  component={Link} to="/Academicth02" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="บทความสมบูรณ์ที่ตีพิมพ์ในรายงานสืบเนื่องจากการประชุมวิชาการระดับชาติ หรือวารสารทางวิชาการระดับชาติที่ไม่อยู่ในฐานข้อมูล" />
                          </ListItem>

                          <ListItem button key="ผลงานที่ได้รับการจดอนุสิทธิบัตร" className={classes.nested2sub}  component={Link} to="/Academicth03" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ผลงานที่ได้รับการจดอนุสิทธิบัตร" />
                          </ListItem>

                          <ListItem button key="บทความวิจัยหรือบทความวิชาการที่ตีพิมพ์ในวารสารวิชาการที่ปรากฎในฐานข้อมูล TCI กลุ่ม2" className={classes.nested2sub}  component={Link} to="/Academicth04" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="บทความวิจัยหรือบทความวิชาการที่ตีพิมพ์ในวารสารวิชาการที่ปรากฎในฐานข้อมูล TCI กลุ่ม2" />
                          </ListItem>

                          <ListItem button key="บทความวิจัยหรือบทความวิชาการที่ตีพิมพ์ในวารสารวิชาการระดับนานาชาติที่ไม่อยู่ในฐานข้อมูล " className={classes.nested2sub}  component={Link} to="/Academicth05" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="บทความวิจัยหรือบทความวิชาการที่ตีพิมพ์ในวารสารวิชาการระดับนานาชาติที่ไม่อยู่ในฐานข้อมูล" />
                          </ListItem>

                          <ListItem button key="บทความวิจัยหรือบทความวิชาการที่ตีพิมพ์ในวารสารวิชาการระดับนานาชาติที่ปรากฎอยู่ในฐานข้อมูลนานาชาติ " className={classes.nested2sub}  component={Link} to="/Academicth06" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="บทความวิจัยหรือบทความวิชาการที่ตีพิมพ์ในวารสารวิชาการระดับนานาชาติที่ปรากฎอยู่ในฐานข้อมูลนานาชาติ" />
                          </ListItem>

                          <ListItem button key="ผลงานที่ได้รับการจดสิทธิบัตร" className={classes.nested2sub}  component={Link} to="/Academicth07" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ผลงานที่ได้รับการจดสิทธิบัตร" />
                          </ListItem>

                          <ListItem button key="ผลงานทางวิชาการรับใช้สังคมที่ได้รับการประเมินผ่านเกณฑ์การขอตำแหน่งทางวิชาการแล้ว" className={classes.nested2sub}  component={Link} to="/Academicth08" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ผลงานทางวิชาการรับใช้สังคมที่ได้รับการประเมินผ่านเกณฑ์การขอตำแหน่งทางวิชาการแล้ว" />
                          </ListItem>

                          <ListItem button key="ผลงานวิจัยที่หน่วยงานหรือองค์กรระดับชาติว่าจ้างให้ดำเนินการ" className={classes.nested2sub}  component={Link} to="/Academicth09" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ผลงานวิจัยที่หน่วยงานหรือองค์กรระดับชาติว่าจ้างให้ดำเนินการ" />
                          </ListItem>

                          <ListItem button key="ผลงานค้นพบพันธ์ุพืช พันธุ์สัตว์ ที่ค้นพบใหม่และได้รับการจดทะเบียน" className={classes.nested2sub}  component={Link} to="/Academicth10" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ผลงานค้นพบพันธ์ุพืช พันธุ์สัตว์ ที่ค้นพบใหม่และได้รับการจดทะเบียน" />
                          </ListItem>

                          <ListItem button key="ตำราหรือหนังสือหรืองานแปรที่ได้รับการประเมินผ่านเกณฑ์การขอตำแหน่งทางวิชาการแล้ว" className={classes.nested2sub}  component={Link} to="/Academicth11" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ตำราหรือหนังสือหรืองานแปรที่ได้รับการประเมินผ่านเกณฑ์การขอตำแหน่งทางวิชาการแล้ว" />
                          </ListItem>

                          <ListItem button key="ตำราหรือหนังสือหรืองานแปรที่ผ่านการพิจารณาตามหลักเกณฑ์การประเมินตำแหน่งทางวิชาการแต่ไม่ได้นำมาขอรับการประเมินตำแหน่งทางวิชาการ" className={classes.nested2sub}  component={Link} to="/Academicth12" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ตำราหรือหนังสือหรืองานแปรที่ผ่านการพิจารณาตามหลักเกณฑ์การประเมินตำแหน่งทางวิชาการแต่ไม่ได้นำมาขอรับการประเมินตำแหน่งทางวิชาการ" />
                          </ListItem>

                          <ListItem button key="จำนวนงานสร้างสรรค์ที่มีการเผยแพร่สู่สาธารณะในลักษณะใดลักษณะหนึ่ง หรือผ่านสืออิเล็กทรอนิกส์ online" className={classes.nested2sub}  component={Link} to="/Academicth13" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="จำนวนงานสร้างสรรค์ที่มีการเผยแพร่สู่สาธารณะในลักษณะใดลักษณะหนึ่ง หรือผ่านสืออิเล็กทรอนิกส์ online" />
                          </ListItem>

                          <ListItem button key="จำนวนงานสร้างสรรค์ที่มีการเผยแพร่ในระดับสถาบัน" className={classes.nested2sub}  component={Link} to="/Academicth14" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="จำนวนงานสร้างสรรค์ที่มีการเผยแพร่ในระดับสถาบัน" />
                          </ListItem>

                          <ListItem button key="จำนวนงานสร้างสรรค์ที่มีการเผยแพร่ในระดับชาติ" className={classes.nested2sub}  component={Link} to="/Academicth15" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="จำนวนงานสร้างสรรค์ที่มีการเผยแพร่ในระดับชาติ" />
                          </ListItem>

                          <ListItem button key="จำนวนงานสร้างสรรค์ที่มีการเผยแพร่ในระดับความร่วมมือระหว่างประเทศ" className={classes.nested2sub}  component={Link} to="/Academicth16" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="จำนวนงานสร้างสรรค์ที่มีการเผยแพร่ในระดับความร่วมมือระหว่างประเทศ" />
                          </ListItem>

                          <ListItem button key="จำนวนงานสร้างสรรค์ที่มีการเผยแพร่ในระดับภูมิภาคอาเซียน" className={classes.nested2sub}  component={Link} to="/Academicth17" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="จำนวนงานสร้างสรรค์ที่มีการเผยแพร่ในระดับภูมิภาคอาเซียน" />
                          </ListItem>

                          <ListItem button key="จำนวนงานสร้างสรรค์ที่มีการเผยแพร่ในระดับนานาชาติ" className={classes.nested2sub}  component={Link} to="/Academicth18" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="จำนวนงานสร้างสรรค์ที่มีการเผยแพร่ในระดับนานาชาติ" />
                          </ListItem>

                          <ListItem button key="จำนวนบทความของอาจารย์ประจำหลักสูตรปริญญาเอกที่ได้รับการอ้างอิงในฐานข้อมูล TCI และ scopus" className={classes.nested2sub}  component={Link} to="/Academicth19" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="จำนวนบทความของอาจารย์ประจำหลักสูตรปริญญาเอกที่ได้รับการอ้างอิงในฐานข้อมูล TCI และ scopus" />
                          </ListItem>

                        </List>
                     </Collapse>
          </List>
        </Collapse> */}


       
    {/* <div className='bgc'>
    <p className='text-center mb-1'>บัณฑิตศึกษา</p> 
    </div> */}
    
   <div className='bgc'>
   <p className='text-center mb-1'>ด้านงานวิจัย/ตีพิมพ์เผยแพร่</p> 
   </div>

    {/* จำนวนผู้สมัครเรียน*/}
    <ListItem button onClick={handleClick11} >
          <ListItemIcon  className='text-white'>
            <InboxIcon />
          </ListItemIcon>
         <ListItemText primary="งานวิจัย" className='text-white'  /> 
          {open11 ? <ExpandLess className='text-white'/> : <ExpandMore className='text-white'/>}
      </ListItem>
        <Collapse in={open11} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
           <ListItem button key="งานวิจัย" className={classes.nested2}   component={Link} to="/Researchall" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="งานวิจัย" />
            </ListItem>
            {/* <ListItem button key="จำนวนผู้รายงานตัว" className={classes.nested2}   component={Link} to="/Studentschoolreportconfirm" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนผู้รายงานตัว" />
            </ListItem>
            <ListItem button key="ผู้สมัครในพื้นที่ให้บริการและนอกพื้นที่ให้บริการ" className={classes.nested2}   component={Link} to="/Studentschoolservicearea" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ผู้สมัครในพื้นที่ให้บริการและนอกพื้นที่ให้บริการ" />
            </ListItem> */}
          </List>
        </Collapse>


     {/* จำนวนผู้สมัครเรียน*/}
    <ListItem button onClick={handleClick12} >
          <ListItemIcon  className='text-white'>
            <InboxIcon />
          </ListItemIcon>
         <ListItemText primary="งานตีพิมพ์เผยแพร่" className='text-white'  /> 
          {open12 ? <ExpandLess className='text-white'/> : <ExpandMore className='text-white'/>}
      </ListItem>
        <Collapse in={open12} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

           <ListItem button key="งานตีพิมพ์เผยแพร่"  className={classes.nested2}   component={Link} to="/Publicall" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="งานตีพิมพ์เผยแพร่" />
            </ListItem>
            {/* <ListItem button key="จำนวนผู้รายงานตัว" className={classes.nested2}   component={Link} to="/Studentschoolreportconfirm" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนผู้รายงานตัว" />
            </ListItem>
            <ListItem button key="ผู้สมัครในพื้นที่ให้บริการและนอกพื้นที่ให้บริการ" className={classes.nested2}   component={Link} to="/Studentschoolservicearea" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ผู้สมัครในพื้นที่ให้บริการและนอกพื้นที่ให้บริการ" />
            </ListItem> */}
          </List>
        </Collapse>

            {/* จำนวนผู้สมัครเรียน*/}
     <div className='bgc'>
         <p className='text-center mb-1 '>ด้านบริหารจัดการ</p> 
      </div>

    <ListItem button onClick={handleClick15} >
          <ListItemIcon  className='text-white'>
            <InboxIcon />
          </ListItemIcon>
         <ListItemText primary="บุคลากร" className='text-white'  /> 
          {open15 ? <ExpandLess className='text-white'/> : <ExpandMore className='text-white'/>}
      </ListItem>
        <Collapse in={open15} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
           <ListItem button key="บุคลากร" className={classes.nested2}   component={Link} to="/Empnum" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนบุคลากร" />
            </ListItem>
            <ListItem button key="จำนวนบุคลากรเกษียณ" className={classes.nested2}   component={Link} to="/Retire" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="จำนวนบุคลากรเกษียณ" />
            </ListItem>
            {/* <ListItem button key="ผู้สมัครในพื้นที่ให้บริการและนอกพื้นที่ให้บริการ" className={classes.nested2}   component={Link} to="/Studentschoolservicearea" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ผู้สมัครในพื้นที่ให้บริการและนอกพื้นที่ให้บริการ" />
            </ListItem> */}
          </List>
        </Collapse>



        {localStorage.getItem('organization_name') === 'คณะพยาบาลศาสตร์' ?<>
 <ListItem button onClick={handleClick13} >
          <ListItemIcon  className='text-white'>
            <InboxIcon />
          </ListItemIcon>
         <ListItemText primary="คณะพยาบาลศาสตร์" className='text-white'  /> 
          {open13 ? <ExpandLess className='text-white'/> : <ExpandMore className='text-white'/>}
        </ListItem>
        <Collapse in={open13} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

                      <ListItem button  key="ระบบสารสนเทศเพื่อการตัดสินใจด้านการบริหาร" onClick={handleClick14} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="ระบบสารสนเทศเพื่อการตัดสินใจด้านการบริหาร"  />
                           {open14 ? <ExpandLess  /> : <ExpandMore  />}
                        </ListItem>
                      <Collapse in={open14} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                          <ListItem button key="ระบบบุคลากรและพัฒนาบุคลากร" className={classes.nested2sub}  component={Link} to="/Nursepersonnel" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ระบบบุคลากรและพัฒนาบุคลากร" />
                          </ListItem>

                          <ListItem button key="ข้อมูลอาจารย์" className={classes.nested2sub}  component={Link} to="/Nurseteacher" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ข้อมูลอาจารย์" />
                          </ListItem>

                          <ListItem button key="ข้อมูลอาจารย์ต่อนักศึกษา" className={classes.nested2sub}  component={Link} to="/Nurseteachertostudent" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ข้อมูลอาจารย์ต่อนักศึกษา" />
                          </ListItem>

                          {/* <ListItem button key="ระบบแผนและงบประมาณ" className={classes.nested2sub}  component={Link} to="" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ระบบแผนและงบประมาณ" />
                          </ListItem> */}

                                          <ListItem button  key="ระบบแผนและงบประมาณ" onClick={handleClick16} className={classes.nested2sub}>
                                              <ListItemIcon >
                                              <StarBorder  />
                                            </ListItemIcon>
                                            <ListItemText primary="ระบบแผนและงบประมาณ"  />
                                            {open16 ? <ExpandLess  /> : <ExpandMore  />}
                                          </ListItem>
                                        <Collapse in={open16} timeout="auto" unmountOnExit>
                                          <List component="div" disablePadding>

                                                <ListItem button key="ข้อมูลยุทธศาสตร์และโครงการ " className={classes.nested2at}  component={Link} to="/Nurseproject" >
                                                  <ListItemIcon>
                                                    <ChevronRightIcon />
                                                  </ListItemIcon>
                                                  <ListItemText primary="ข้อมูลยุทธศาสตร์และโครงการ " />
                                                </ListItem>

                                                <ListItem button key="ข้อมูลงบประมาณ " className={classes.nested2at}  component={Link} to="/Nursebudget" >
                                                  <ListItemIcon>
                                                    <ChevronRightIcon />
                                                  </ListItemIcon>
                                                  <ListItemText primary="ข้อมูลงบประมาณ " />
                                                </ListItem>

                                                <ListItem button key="เปรียบเทียบงบประมาณที่จัดสรร" className={classes.nested2at}  component={Link} to="/Nursetotalbudget" >
                                                  <ListItemIcon>
                                                    <ChevronRightIcon />
                                                  </ListItemIcon>
                                                  <ListItemText primary="เปรียบเทียบงบประมาณที่จัดสรร" />
                                                </ListItem>

                                          </List>
                                      </Collapse>

                          <ListItem button key="ระบบสินทรัพย์" className={classes.nested2sub}  component={Link} to="/Nursedurablearticles" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ระบบสินทรัพย์" />
                          </ListItem>

                        </List>
                     </Collapse>



           {/* <ListItem button key="ระบบสารสนเทศเพื่อการตัดสินใจด้านการเรียนการสอน/ผลิตบัณฑิต" className={classes.nested2}   component={Link} to="" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ระบบสารสนเทศเพื่อการตัดสินใจด้านการเรียนการสอน/ผลิตบัณฑิต" />
            </ListItem> */}
            {/* <ListItem button key="ระบบสารสนเทศเพื่อการตัดสินใจด้านวิจัย" className={classes.nested2}   component={Link} to="" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ระบบสารสนเทศเพื่อการตัดสินใจด้านวิจัย" />
            </ListItem> */}


                    <ListItem button  key="ระบบสารสนเทศเพื่อการตัดสินใจด้านการเรียนการสอน/ผลิตบัณฑิต" onClick={handleClick18} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="ระบบสารสนเทศเพื่อการตัดสินใจด้านการเรียนการสอน/ผลิตบัณฑิต"  />
                           {open18 ? <ExpandLess  /> : <ExpandMore  />}
                        </ListItem>
                      <Collapse in={open18} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                          <ListItem button key="จำนวนนักศึกษา" className={classes.nested2sub}  component={Link} to="/Nursenumstd" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="จำนวนนักศึกษา" />
                          </ListItem>

                           <ListItem button key="จำนวนผู้สำเร็จ" className={classes.nested2sub}  component={Link} to="/Nursenumgraduate" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="จำนวนผู้สำเร็จ" />
                          </ListItem>

                          <ListItem button key="ข้อมูลหลักสูตร(มคอ. 2) " className={classes.nested2sub}  component={Link} to="/Nursecurriculum" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ข้อมูลหลักสูตร(มคอ. 2) " />
                          </ListItem>

                          <ListItem button key="ข้อมูลมคอ 3,4,5,6" className={classes.nested2sub}  component={Link} to="/Nursemko" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ข้อมูลมคอ 3,4,5,6" />
                          </ListItem>

                          <ListItem button key="ตำราหลัก 5 สาขาวิชา " className={classes.nested2sub}  component={Link} to="/Nursebook" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ตำราหลัก 5 สาขาวิชา " />
                          </ListItem>

                          <ListItem button key="การประเมินการจัดการเรียนการสอน" className={classes.nested2sub}  component={Link} to="/Nurseestimate" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="การประเมินการจัดการเรียนการสอน" />
                          </ListItem>

                          <ListItem button key="ระบบกิจการนักศึกษา" className={classes.nested2sub}  component={Link} to="/Nursedevelopstudents" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ระบบกิจการนักศึกษา" />
                          </ListItem>

                        </List>
                     </Collapse>



                     <ListItem button  key="ระบบสารสนเทศเพื่อการตัดสินใจด้านวิจัย" onClick={handleClick17} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="ระบบสารสนเทศเพื่อการตัดสินใจด้านวิจัย"  />
                           {open17 ? <ExpandLess  /> : <ExpandMore  />}
                        </ListItem>
                      <Collapse in={open17} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                          <ListItem button key="จำนวนงานวิจัย" className={classes.nested2sub}  component={Link} to="/Nurseresearch" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="จำนวนงานวิจัย" />
                          </ListItem>

                          <ListItem button key="จำนวนงานตีพิมพ์" className={classes.nested2sub}  component={Link} to="/Nursepublic" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="จำนวนงานตีพิมพ์" />
                          </ListItem>

                          {/* <ListItem button key="ระบบสินทรัพย์" className={classes.nested2sub}  component={Link} to="" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ระบบสินทรัพย์" />
                          </ListItem> */}

                        </List>
                     </Collapse>



            <ListItem button key="ระบบสารสนเทศเพื่อการตัดสินใจด้านบริการวิชาการ" activeClassName={classes.nested2at}  className={classes.nested2}  component={Link} to="/NurseAcademicservices"  >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ระบบสารสนเทศเพื่อการตัดสินใจด้านบริการวิชาการ" />
            </ListItem>
             {/* <ListItem button key="ระบบสารสนเทศเพื่อการตัดสินใจด้านทำนุบำรุงศิลปะวัฒนธรรม" className={classes.nested2}   component={Link} to="/Nurseartsandculture" selected={"" === pddp} >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="ระบบสารสนเทศเพื่อการตัดสินใจด้านทำนุบำรุงศิลปะวัฒนธรรม" />
            </ListItem> */}

            <ListItem button  key="ระบบสารสนเทศเพื่อการตัดสินใจด้านทำนุบำรุงศิลปะวัฒนธรรม" onClick={handleClick19} className={classes.nested2}>
                            <ListItemIcon >
                             <PeopleIcon  />
                           </ListItemIcon>
                           <ListItemText primary="ระบบสารสนเทศเพื่อการตัดสินใจด้านทำนุบำรุงศิลปะวัฒนธรรม"  />
                           {open19 ? <ExpandLess  /> : <ExpandMore  />}
                        </ListItem>
                      <Collapse in={open19} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>

                          <ListItem button key="ทำนุบำรุงศิลปวัฒนธรรม" className={classes.nested2sub}  component={Link} to="/Nurseartsandculture" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ทำนุบำรุงศิลปวัฒนธรรม" />
                          </ListItem>

                          <ListItem button key="จำนวนผู้เข้าร่วมโครงการทำนุบำรุงศิลปวัฒนธรรม" className={classes.nested2sub}  component={Link} to="/NurseActivitytype" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="จำนวนผู้เข้าร่วมโครงการทำนุบำรุงศิลปวัฒนธรรม" />
                          </ListItem>

                          {/* <ListItem button key="ระบบสินทรัพย์" className={classes.nested2sub}  component={Link} to="" >
                            <ListItemIcon>
                              <StarBorder />
                            </ListItemIcon>
                            <ListItemText primary="ระบบสินทรัพย์" />
                          </ListItem> */}

                        </List>
                     </Collapse>

          
          </List>
        </Collapse>

</>:<></>}
     
 

{localStorage.getItem('type2') === '000961' ?<>
 <ListItem button onClick={handleClickadmin} >
          <ListItemIcon  className='text-white'>
            <InboxIcon />
          </ListItemIcon>
         <ListItemText primary="สำหรับ Admin" className='text-white'  /> 
          {openadmin ? <ExpandLess className='text-white'/> : <ExpandMore className='text-white'/>}
        </ListItem>
        <Collapse in={openadmin} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>

           <ListItem button key="นำเข้าข้อมูลนักเรียน" className={classes.nested2}   component={Link} to="/Studentschoolreport" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="นำเข้าข้อมูลนักเรียน" />
            </ListItem>
            <ListItem button key="นำเข้าข้อมูลบัณฑิต" className={classes.nested2}   component={Link} to="/Masterreport" >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="นำเข้าข้อมูลบัณฑิต" />
            </ListItem>
            <ListItem button key="นำเข้าข้อมูลตีพิมพ์" activeClassName={classes.nested2at}  className={classes.nested2}  component={Link} to="/Publicreport"  >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="นำเข้าข้อมูลตีพิมพ์" />
            </ListItem>
             <ListItem button key="นำเข้าข้อมูลงานวิจัย" className={classes.nested2}   component={Link} to="/Publicresearch" selected={"/Publicresearch" === pddp} >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="นำเข้าข้อมูลงานวิจัย" />
            </ListItem>
            <ListItem button key="นำเข้าข้อมูลจำนวนผู้สำเร็จ" activeClassName={classes.nested2at}  className={classes.nested2}  component={Link} to="/Numfinshstudent"  >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="นำเข้าข้อมูลจำนวนผู้สำเร็จ" />
            </ListItem>

             <ListItem button key="อัพเดทข้อมูลทั้งหมด" activeClassName={classes.nested2at}  className={classes.nested2}  component={Link} to="/Updatedataall"  >
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="อัพเดทข้อมูลทั้งหมด" />
            </ListItem>

          
            
          </List>
        </Collapse>

</>:<></>}
       

{/* 
        <ListItem button   component={Link} to="/Sitemap" >
          <ListItemIcon  className='text-red' >
            <ExitToAppIcon />
          </ListItemIcon>
         <ListItemText primary="Sitemap" className='text-red'  /> 
          {open50 ? <ExpandLess className='text-white'/> : <ExpandMore className='text-white'/>}
         </ListItem>
        <Collapse in={open49} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
         
          </List>
        </Collapse> */}

       


        <Divider />
  
        <ListItem button onClick={logout} className={classes.nested3}>
          <ListItemIcon  className='text-red' >
            <ExitToAppIcon />
          </ListItemIcon>
         <ListItemText primary="ออกจากระบบ" className='text-red'  /> 
          {/* {open50 ? <ExpandLess className='text-white'/> : <ExpandMore className='text-white'/>} */}
         </ListItem>
        <Collapse in={open50} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
          </List>
        </Collapse>
     
       
  

        </div>
      <Divider />

     
        {/* <div className="footer--pin1 "> */}
           {/* <ListItem button onClick={logout}>
          <ListItemIcon className='text-white'>
            <InboxIcon  />
          </ListItemIcon>
          <ListItemText primary="ออกจากระบบ" className='text-white' />
          {open4 ? <ExpandLess className='text-white' /> : <ExpandMore  className='text-white'/>}
        </ListItem> */}
        {/* <ListItem button key="ออกจากระบบ" onClick={logout}  className='text-white'>
      
            <ListItemIcon>{1 % 2 === 0 ? 
            // <InboxIcon className='text-white' />
            <></>
             : 
            // <ExitToAppOutlinedIcon className='text-white'/>
            <></>
            }
            </ListItemIcon>
            <Button variant="outlined" color="secondary"  className='text-white'>
            ออกจากระบบ
            </Button>
           
        </ListItem> */}
        {/* <p className='text-center text-white'> v 1.0.0</p>   */}
        {/* </div> */}
    
    
      {/* <List>
        {['All mail', 'Trash', 'Spam'].map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List> */}
    </div>
  );

  const container = window2 !== undefined ? () => window().document.body : undefined;
  const ddd = 'IconButton'
  return (
//  {pp === 0 ?<>  </>:<>
//  <Login/>

//  </> }
    <div className={classes.root}  >




      <CssBaseline  />
      <Router basename="/" >
      <AppBar position="fixed" className={classes.appBar}  >
       
        <Toolbar color="gray" >
          <ddd
          // color={accent2}
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          //  backgroundColor:alpha(theme.palette.grey[300], 2.55),
          >
            <MenuIcon className='red-text' />
          </ddd>
 
          <Typography className='red-text' variant="h6" noWrap >
             KPRU DASHBOARD
          </Typography>
        </Toolbar>
        
      </AppBar>
     
       <nav className={classes.drawer} aria-label="mailbox folders" >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
   
        <Hidden implementation="css">
          <Drawer
          // style={{ backgroundImage: `url(${"https://img.freepik.com/free-vector/hand-painted-watercolor-pastel-sky-background_23-2148902771.jpg?w=2000"})`}}
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >      
            {drawer}
            
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css" >
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
            
          </Drawer>
        </Hidden>
       
       </nav>

    
        {/* <div className="bg3"/> */}
       <main className={classes.content }   >     
      
       
        
          <MDBContainer className=" my-5  " fluid>
          <br/>  
         {/* <h2 className='text-center special-color-text'>ระบบสารสนเทศ สำนักส่งเสริมวิชาการและงานทะเบียน</h2>
         <h4 className='text-center special-color-text'>มหาวิทยาลัยราชภัฏกำแพงเพชร</h4> */}
               <div className="content-container mt-2 ">  


                            <Switch>
                            {localStorage.getItem('type2') !== null ?<>
                               <Route exact path="/welcome" component={welcome} />
                                <Route exact path="/" component={Login} />
                                <Route exact path="/login" component={Login} />
                                <Route exact path="/login/:user1/:pass" component={Loginforapp} />
                                <Route exact path="/loginforapp/:user1/:pass" component={Loginforapp} />
                                <Route exact path="/Studentreport" component={Studentreport} />
                                <Route exact path="/Studentschoolreport" component={Studentschoolreport} />
                                <Route exact path="/Studentschoolreportconfirm" component={Studentschoolreportconfirm} />
                                <Route exact path="/Studentkpru" component={Studentkpru} />
                                <Route exact path="/StudentDropout" component={StudentDropout} />
                                <Route exact path="/StudentGraduate" component={StudentGraduate} />
                                <Route exact path="/Studentcurr" component={Studentcurr} />
                                <Route exact path="/Studentfinish" component={Studentfinish} />
                                <Route exact path="/Studentschoolmis" component={Studentschoolmis} />

                                <Route exact path="/Doctoraldegree" component={Doctoraldegree} />
                                <Route exact path="/Bachelordegree" component={Bachelordegree} />
                                <Route exact path="/Masterdegree" component={Masterdegree} />
                                <Route exact path="/Certificatecourse" component={Certificatecourse} />

                                <Route exact path="/teacherbachelordegree" component={teacherbachelordegree} />
                                <Route exact path="/teachermasterdegree" component={teachermasterdegree} />
                                <Route exact path="/teacherdoctoraldegree" component={teacherdoctoraldegree} />

                                <Route exact path="/teeteacherbachelordegree" component={teeteacherbachelordegree} />
                                <Route exact path="/toteacherbachelordegree" component={toteacherbachelordegree} />
                                <Route exact path="/aekteacherbachelordegree" component={aekteacherbachelordegree} />

                                <Route exact path="/apteeteacher" component={apteeteacher} />
                                <Route exact path="/apaekteacher" component={apaekteacher} />
                                <Route exact path="/aptoteacher" component={aptoteacher} />

                                <Route exact path="/Asspteeteacher" component={Asspteeteacher} />
                                <Route exact path="/Assptoteacher" component={Assptoteacher} />
                                <Route exact path="/Asspaekteacher" component={Asspaekteacher} />

                                <Route exact path="/Proteeteacher" component={Proteeteacher} />
                                <Route exact path="/Prototeacher" component={Prototeacher} />
                                <Route exact path="/Proaekteacher" component={Proaekteacher} />

                                <Route exact path="/teacherculiculumtee" component={teacherculiculumtee} />
                                <Route exact path="/teacherculiculumto" component={teacherculiculumto} />
                                <Route exact path="/teacherculiculumaek" component={teacherculiculumaek} />
                                <Route exact path="/teacherculiculumno" component={teacherculiculumno} />
                                <Route exact path="/teacherculiculumap" component={teacherculiculumap} />
                                <Route exact path="/teacherculiculumassp" component={teacherculiculumassp} />
                                <Route exact path="/teacherculiculumpro" component={teacherculiculumpro} />

                                <Route exact path="/Studentworkall" component={Studentworkall} />
                                <Route exact path="/Studentsentworkafteryear" component={Studentsentworkafteryear} />
                                <Route exact path="/Studentworkforfinsh" component={Studentworkforfinsh} />
                                <Route exact path="/Studentworkfreelance" component={Studentworkfreelance} />
                                <Route exact path="/Studentgetworkbeforlearn" component={Studentgetworkbeforlearn} />
                                <Route exact path="/Studentworksalary" component={Studentworksalary} />
                                <Route exact path="/Studentcontinuing" component={Studentcontinuing} />
                                <Route exact path="/Studenttqf" component={Studenttqf} />
                                <Route exact path="/Studentregularincome" component={Studentregularincome} />
                                <Route exact path="/Studentordination" component={Studentordination} />
                                <Route exact path="/Studentsoldier" component={Studentsoldier} />
                                <Route exact path="/Sitemap" component={Sitemap} />
                                <Route exact path="/Masterreport" component={Masterreport} />
                                <Route exact path="/Academicto01" component={Academicto01} />
                                <Route exact path="/Academicto02" component={Academicto02} />
                                <Route exact path="/Academicto03" component={Academicto03} />
                                <Route exact path="/Academicto04" component={Academicto04} />
                                <Route exact path="/Academicto05" component={Academicto05} />
                                <Route exact path="/Academicto06" component={Academicto06} />
                                <Route exact path="/Academicto07" component={Academicto07} />
                                <Route exact path="/Academicto08" component={Academicto08} />
                                <Route exact path="/Academicto09" component={Academicto09} />
                                <Route exact path="/Academicto10" component={Academicto10} />
                                <Route exact path="/Academicto11" component={Academicto11} />
                                <Route exact path="/Academicto12" component={Academicto12} />
                                <Route exact path="/Academicto13" component={Academicto13} />
                                <Route exact path="/Academicto14" component={Academicto14} />

                                <Route exact path="/Academicaek01" component={Academicaek01} />
                                <Route exact path="/Academicaek02" component={Academicaek02} />
                                <Route exact path="/Academicaek03" component={Academicaek03} />
                                <Route exact path="/Academicaek04" component={Academicaek04} />
                                <Route exact path="/Academicaek05" component={Academicaek05} />
                                <Route exact path="/Academicaek06" component={Academicaek06} />
                                <Route exact path="/Academicaek07" component={Academicaek07} />
                                <Route exact path="/Academicaek08" component={Academicaek08} />
                                <Route exact path="/Academicaek09" component={Academicaek09} />
                                <Route exact path="/Academicaek10" component={Academicaek10} />
                                <Route exact path="/Academicaek11" component={Academicaek11} />
                                <Route exact path="/Academicaek12" component={Academicaek12} />
                                <Route exact path="/Academicaek13" component={Academicaek13} />
                                <Route exact path="/Academicaek14" component={Academicaek14} />

                                <Route exact path="/Publicreport" component={Publicreport} />

                                <Route exact path="/Academicth01" component={Academicth01} />
                                <Route exact path="/Academicth02" component={Academicth02} />
                                <Route exact path="/Academicth03" component={Academicth03} />
                                <Route exact path="/Academicth04" component={Academicth04} />
                                <Route exact path="/Academicth05" component={Academicth05} />
                                <Route exact path="/Academicth06" component={Academicth06} />
                                <Route exact path="/Academicth07" component={Academicth07} />
                                <Route exact path="/Academicth08" component={Academicth08} />
                                <Route exact path="/Academicth09" component={Academicth09} />
                                <Route exact path="/Academicth10" component={Academicth10} />
                                <Route exact path="/Academicth11" component={Academicth11} />
                                <Route exact path="/Academicth12" component={Academicth12} />
                                <Route exact path="/Academicth13" component={Academicth13} />
                                <Route exact path="/Academicth14" component={Academicth14} />
                                <Route exact path="/Academicth15" component={Academicth15} />
                                <Route exact path="/Academicth16" component={Academicth16} />
                                <Route exact path="/Academicth17" component={Academicth17} />
                                <Route exact path="/Academicth18" component={Academicth18} />
                                <Route exact path="/Academicth19" component={Academicth19} />
                                <Route exact path="/Studentschoolservicearea" component={Studentschoolservicearea} />
                                <Route exact path="/Publicresearch" component={Publicresearch} />
                                <Route exact path="/Publicall" component={Publicall} />
                                <Route exact path="/Researchall" component={Researchall} />
                                <Route exact path="/Studentprofession" component={Studentprofession} />
                                <Route exact path="/Studentmasterdegree" component={Studentmasterdegree} />
                                <Route exact path="/Bachelordegreeopen" component={Bachelordegreeopen} />
                                <Route exact path="/teacherall" component={teacherall} />
                                <Route exact path="/Studentworkall2" component={Studentworkall2} />
                                <Route exact path="/Studentconfirmservicearea" component={Studentconfirmservicearea} />
                                <Route exact path="/Certificatecourseopen" component={Certificatecourseopen} />
                                <Route exact path="/Doctoraldegreeopen" component={Doctoraldegreeopen} />
                                <Route exact path="/teacherculiculumall" component={teacherculiculumall} />
                                <Route exact path="/Studentmov" component={Studentmov} />
                                <Route exact path="/Nursepersonnel" component={Nursepersonnel} />
                                <Route exact path="/Academicth011" component={Academicth011} />
                                <Route exact path="/Empnum" component={Empnum} />
                                <Route exact path="/Nurseproject" component={Nurseproject} />
                                <Route exact path="/Nursebudget" component={Nursebudget} />
                                <Route exact path="/Nursetotalbudget" component={Nursetotalbudget} />
                                <Route exact path="/Studentreportstatus" component={Studentreportstatus} />
                                <Route exact path="/Studentkpruonschool" component={Studentkpruonschool} />
                                <Route exact path="/Nurseteacher" component={Nurseteacher} />
                                <Route exact path="/Nurseresearch" component={Nurseresearch} />
                                <Route exact path="/Nursepublic" component={Nursepublic} />
                                <Route exact path="/Nursedurablearticles" component={Nursedurablearticles} />
                                <Route exact path="/Nursenumstd" component={Nursenumstd} />
                                <Route exact path="/Nursecurriculum" component={Nursecurriculum} />
                                <Route exact path="/Studentkprutoregister" component={Studentkprutoregister} />
                                <Route exact path="/Studentreportyear" component={Studentreportyear} />
                                <Route exact path="/Nursemko" component={Nursemko} />
                                <Route exact path="/Editpasswordmember" component={Editpasswordmember} />
                                <Route exact path="/Nursebook" component={Nursebook} />
                                <Route exact path="/Nurseestimate" component={Nurseestimate} />
                                <Route exact path="/Nursenumgraduate" component={Nursenumgraduate} />
                                <Route exact path="/NurseAcademicservices" component={NurseAcademicservices} />
                                <Route exact path="/Nurseartsandculture" component={Nurseartsandculture} />
                                <Route exact path="/Nursedevelopstudents" component={Nursedevelopstudents} />
                                <Route exact path="/NurseActivitytype" component={NurseActivitytype} />
                                <Route exact path="/Numfinshstudent" component={Numfinshstudent} />
                                <Route exact path="/Updatedataall" component={Updatedataall} />
                                <Route exact path="/StudentNotpaid" component={StudentNotpaid} />
                                <Route exact path="/Masterreportssy" component={Masterreportssy} />
                                <Route exact path="/Masterreportpay" component={Masterreportpay} />
                                <Route exact path="/Masterreportpositionnumber" component={Masterreportpositionnumber} />
                                <Route exact path="/Retire" component={Retire} />
                                 <Route exact path="/Nurseteachertostudent" component={Nurseteachertostudent} />
                                 <Route exact path="/Culiculumcreditbank" component={Culiculumcreditbank} />
                                 <Route exact path="/Schoolcreditbank" component={Schoolcreditbank} />
                                
                                {/* <Route render={function () {return  <h1>Not Founsd</h1> }} /> */}


                                </>:<>
                                <Route exact path="/login" component={Login} />
                            </>}  
                            </Switch> 
                           
                            </div>




             
          </MDBContainer>
  

        </main>
     <Foottermobil handleDrawerToggle={handleDrawerToggle} /> 
      </Router>

    </div>
    
  );
}

Main.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window2: PropTypes.func,
};

export default Main;